const ACTIVE_EVENT_KEY = "stb_org_active_event_id";

/** Event id when the organizer is inside `/events/dashboard/:eventId/...`. */
export function dashboardEventIdFromPath(pathname = "") {
  const match = String(pathname).match(/\/events\/dashboard\/([^/?#]+)(?:\/|$)/);
  const id = decodeURIComponent(match?.[1] || "").trim();
  if (!id || id === "cash-booking") return "";
  return id;
}

export function rememberActiveEventId(eventId) {
  const id = String(eventId || "").trim();
  if (!id) return;
  try {
    sessionStorage.setItem(ACTIVE_EVENT_KEY, id);
  } catch {
    /* ignore */
  }
}

export function readRememberedEventId() {
  try {
    return String(sessionStorage.getItem(ACTIVE_EVENT_KEY) || "").trim();
  } catch {
    return "";
  }
}

export function resolveLockedEventId({ pathname, state, searchParams, params } = {}) {
  const fromPath = dashboardEventIdFromPath(pathname);
  if (fromPath) {
    rememberActiveEventId(fromPath);
    return fromPath;
  }
  if (String(pathname || "").includes("/events/dashboard/") && params?.id) {
    const fromParams = String(params.id).trim();
    if (fromParams && fromParams !== "cash-booking") {
      rememberActiveEventId(fromParams);
      return fromParams;
    }
  }
  const fromState = state?.eventId ? String(state.eventId).trim() : "";
  if (fromState) {
    rememberActiveEventId(fromState);
    return fromState;
  }
  const fromQuery = String(searchParams?.get?.("eventId") || "").trim();
  if (fromQuery) {
    rememberActiveEventId(fromQuery);
    return fromQuery;
  }
  return readRememberedEventId();
}

export function dashboardPath(eventId) {
  const id = String(eventId || "").trim();
  return id ? `/events/dashboard/${id}` : "/listyourshow/manage";
}

export function issueTicketPath(eventId) {
  const id = String(eventId || "").trim();
  return id ? `/events/dashboard/${id}/cash-booking` : "/listyourshow/manage";
}

export function offlineBookingsPath(eventId) {
  const id = String(eventId || "").trim();
  return id ? `/listyourshow/cash-bookings?eventId=${id}` : "/listyourshow/cash-bookings";
}
